enum MailchimpTiers {
  FREE = 'free',
  ESSENTIALS = 'essentials',
  STANDARD = 'standard',
  PREMIUM = 'premium',
}

export default MailchimpTiers;
